import { createGlobalStyle } from 'styled-components';

import AgencyB from '../assets/fonts/AFB.ttf';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: "Agency FB";
        src: url(${AgencyB});
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        unicode-range: U+000-5FF; //Download only latin glyphs  
    }

    :root {
        --blue-menu: #001529;
        --blue-button-menu: #002140;
        --blue-button: #1890ff;
        --egyptianBlue: #15348F;
        --cobaltBlue: #004BA8;
        --hanBlue: #4B6DD1;
        --spaceCadet: #32394F;
        --jet: #2D2E33;

        --header-height: 60px;
        
        --zindex-menu: 10;
    }     

    * { 
        margin: 0;
        padding: 0;
        border: 0;
        box-sizing: border-box;
        font-family: "Agency FB", Arial, sans-serif;
    }

    html{
        scroll-behavior: smooth;
        @media (max-width: 1080px){
            font-size: 93.75%;
        }
        @media (max-width: 720px){
            font-size: 87.5%;
        }
    }

    body {
        -webkit-font-smoothing: antialiased;
        background: ${(props) => props.theme.background};
        color: ${(props) => props.theme.text};   
    }

    button {
        cursor: pointer;
        border: 0;
    }

    textarea:focus, input:focus, select:focus {
        box-shadow: 0 0 0 0;
        outline: 0;
    } 

    ::selection {
        background: transparent;
        color: inherit;
    }

    input{
        ::selection{
            background: ${(props) => props.theme.purple};
            color: ${(props) => props.theme.white};
        }
    }

    [disabled] {
        opacity: 0.6;
        cursor: not-allowed;
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    ::-webkit-scrollbar-track {
        background-color: ${({ theme }) => theme.backgroundCard};  
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.text};
        border-radius: 16px;
    }
`;
